const firebaseConfig = {
    apiKey: "AIzaSyDBAXnyNLqFopDwvwK8Vb81F7i6Fma-hPU",
    authDomain: "cleveland-state-henshu.firebaseapp.com",
    projectId: "cleveland-state-henshu",
    storageBucket: "cleveland-state-henshu.appspot.com",
    messagingSenderId: "743877514112",
    appId: "1:743877514112:web:cc893d7f6c856600d7e765"
};

export default firebaseConfig;
